import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const ShrinkIcon = () => <FontAwesomeIcon icon={["fas", "compress"]}/>

export default ShrinkIcon;